<template>
  <div>
    <div class="row">
      <div class="form-group mb-2 col-lg-3 konumAuto p-0">
        <div class="col-lg-12">
          <GmapAutocomplete
            ref="autocomplete"
            :placeholder="$t('crm.customers.addressSearch')"
            :class="{ 'field': false, 'form-control': true, 'container__input': true }"
            :value="address"
            name="address"
            @input="v => $emit(&quot;addressChanged&quot;, v.target.value)"
            @place_changed="setPlace"
          >
            <label class="container__label">{{ 'Address' }}</label>
          </GmapAutocomplete>
        </div>
      </div>
      <t-input
        :value="state"
        :label="$t('common.googleautocomplate.state')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;stateChanged&quot;, v)"
      />
      <t-input
        :value="city"
        :label="$t('common.googleautocomplate.city')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;cityChanged&quot;, v)"
      />
      <t-input
        :value="town"
        :label="$t('common.googleautocomplate.district')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;townChanged&quot;, v)"
      />

      <t-input
        :value="postCode"
        :label="$t('common.googleautocomplate.postCode')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;postCodeChanged&quot;, v)"
      />
      <t-input
        :value="country"
        :label="$t('common.googleautocomplate.country')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;countryChanged&quot;, v)"
      />
      <t-input
        :value="street"
        :label="$t('common.googleautocomplate.street')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;streetChanged&quot;, v)"
      />
      <t-input
        :value="neighborhood"
        :label="$t('common.googleautocomplate.neighborhood')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;neighborhoodChanged&quot;, v)"
      />
      <t-input
        :value="streetNumber"
        :label="$t('common.googleautocomplate.streetNumber')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;streetNumberChanged&quot;, v)"
      />
      <t-input
        :value="buildingNumber"
        :label="$t('common.googleautocomplate.buildingNumber')"
        wrapper-class="col-lg-3 form-group"
        form-control
        type="text"
        @input="v => $emit(&quot;buildingNumberChanged&quot;, v)"
      />
    </div>
  </div>
</template>
<script>
import TInput from '../input'
export default {
	name: 't-google-auto-complete',
	components: { TInput },
	props: {
		address: {
			type: String,
			default: null
		},
		country: {
			type: String,
			default: null
		},
		state: {
			type: String,
			default: null
		},
		city: {
			type: String,
			default: null
		},
		town: {
			type: String,
			default: null
		},
		postCode: {
			type: String,
			default: null
		},
		street: {
			type: String,
			default: null
		},
		neighborhood: {
			type: String,
			default: null
		},
		streetNumber: {
			type: String,
			default: null
		},
		buildingNumber: {
			type: String,
			default: null
		}
	},
	data () {
		return {}
	},
	methods: {
		setPlace (place) {
			let info = {
				locality: null,
				administrative_area_level_1: null,
				administrative_area_level_2: null,
				postal_code: null,
				country: null,
				route: null, // sokak
				administrative_area_level_4: null,
				street_number: null, // mahalle
				sublocality_level_1: null
			}

			if (place.address_components) {
				for (let i = 0; i < place.address_components.length; i++) {
					let addressType = place.address_components[i].types[0]
					if (info.hasOwnProperty(addressType)) {
						// gelen keyler arasında bizim googleInputs da eşleşen key varmı
						let val = place.address_components[i]['long_name']
						info[addressType] = val
					}
				}
			}

			this.$emit('placeChanged', {
				state: info.administrative_area_level_1,
				city: info.locality,
				town:
          info.sublocality_level_1 === null
          	? info.administrative_area_level_2
          	: info.sublocality_level_1, // sublocality_level_1, avrupada ilçe olarak geçiyor. Eğer dolu ise onu baz al.Değilse administrative_area_level_2. Çünkü türkiyedeki adreslerde sublocality_level_1 diye bir key yok
				postCode: info.postal_code,
				country: info.country,
				street: info.route,
				neighborhood: info.administrative_area_level_4,
				streetNumber: info.street_number,
				buildingNumber: null
			})
		}
	}
}
</script>

<style scoped>
.container__input:focus + label {
  border: 1px solid #047bf8;
}

.container__form.validateInput label {
  top: -9px;
  left: -5pxpx;
  height: 10%;
  padding: 0.8em 1em;
  color: #6a6d71!important;
    background: noneimportant;
    border: none!important;
}
.container__label {
  position: absolute;
  top: 14px;
  left: 4px;
  height: 10%;
  padding: 0.2em 1em;
  background-color: transparent;
  display: flex;

  align-items: center;
  color: #80868b;
  text-transform: uppercase;
  font-size: 0.7rem;
  width: auto;
}
.container__form {
  position: relative;
}
.container__input {
  width: 100%;
  height: 40px;
  padding: 1em;
  border: 1px solid #dadce0;
  background-color: transparent;
  color: #252a32;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/common/google-auto-complete/index.vue